import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { statLabels } from '@sorare/core/src/lib/scoring';

import { TutorialBezel } from '../../TutorialBezel';
import { Stat } from '../Stat';

const Root = styled(Horizontal)`
  padding: calc(8 * var(--unit));
  height: 100%;
`;

export const NegativeActions = () => {
  return (
    <TutorialBezel color="var(--c-rare)">
      <Root center>
        <Stat
          color="var(--c-rare)"
          value={-2}
          label={<FormattedMessage {...statLabels.turnovers} />}
        />
      </Root>
    </TutorialBezel>
  );
};
